import { RgDataSetID } from '../rg-data-set-id.js';
import { modulousIDsUk01v1 } from './modulous-ids-uk01-v1.js';
import { modulousIDsUk02v1 } from './modulous-ids-uk02-v1.js';

/** Record of modulousIds, accessible via {@link RgDataSetID} */
const modulousIDs = {
    [RgDataSetID.uk_01]: modulousIDsUk01v1,
    [RgDataSetID.uk_02]: modulousIDsUk02v1
};

export { modulousIDs };
//# sourceMappingURL=modulous-ids.js.map
